export default {
  methods: {
    openModal(data) {
      if (data) {
        this.modalData = data
      }
      this.isModalShow = true
    },
    closeModal() {
      this.isModalShow = false
    },
    toggleModal() {
      this.isModalShow = !this.isModalShow
    },
  },
  data() {
    return {
      modalData: '',
      isModalShow: false,
    }
  },
}
